/**
 * Onboarding Welcome Modal — shown once after first signup
 */

import { useProfile, useAuthStore } from '../store/useAuthStore';

export default function OnboardingModal() {
  const profile = useProfile();
  const { setOnboarded } = useAuthStore();

  if (!profile || profile.onboarded) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-in fade-in">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-indigo-100 rounded-2xl flex items-center justify-center">
            <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
            </svg>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-slate-900 text-center mb-2">
          Welcome to LinguistPro!
        </h2>
        <p className="text-slate-500 text-center mb-6">
          You have <span className="font-semibold text-indigo-600">30 minutes</span> of free transcription to get started.
        </p>

        <ul className="space-y-3 mb-8">
          <li className="flex items-start gap-3">
            <span className="mt-0.5 w-5 h-5 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">1</span>
            <span className="text-sm text-slate-600">Upload any audio or video file — MP3, WAV, MP4, and more</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="mt-0.5 w-5 h-5 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">2</span>
            <span className="text-sm text-slate-600">AI identifies speakers and transcribes with timestamps</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="mt-0.5 w-5 h-5 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">3</span>
            <span className="text-sm text-slate-600">Get executive summaries, action items, and sentiment analysis</span>
          </li>
        </ul>

        <button
          onClick={setOnboarded}
          className="w-full py-3 px-4 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors"
        >
          Start transcribing
        </button>
      </div>
    </div>
  );
}
